/** 分期商城相关 埋点 汇总 */
/** 分期商城模块-曝光 - expose */
export const shopMallModuleExpose = 'finance_loan_shopMall';
/** 分期商城模块-按钮点击 - click */
export const shopMallModuleClick = `${shopMallModuleExpose}_button`;

/** 分期商城协议-曝光 - expose */
export const shopMallAgreementPopupExpose = `${shopMallModuleExpose}_agreementPopup_expose`;
/** 分期商城协议-点击 - click */
export const shopMallAgreementPopupClick = `${shopMallModuleExpose}_agreementPopup_click`;
